<template>
	<el-drawer title="修改信息" :visible.sync="show" :before-close="close" :close-on-press-escape="false" :destroy-on-close="true" :wrapperClosable="false" :size="400">
		<div class="tit f-l fdqx-b bg-f" style="position: fixed;top: 40px;right: 20px;width: 380px;height: 50px;z-index: 9999;">
			<p>姓名：{{user.name}}</p>
			<div>
				<el-button @click="reset">重置</el-button>
				<el-button type="primary" @click="submit">提交</el-button>
			</div>
		</div>
		<el-form :model="form" :rules="rules" ref="from" label-width="100px" style="margin-top: 40px;">
			<el-form-item class="item" label="性别" prop="sex"><el-select v-model="form.sex" placeholder="请选择"><el-option key="男" label="男" value="男"></el-option><el-option key="女" label="女" value="女"></el-option></el-select></el-form-item>
			<el-form-item class="item" label="入职日期" prop="startTimeS"><el-date-picker style="width: 200px;" v-model="form.startTimeS" type="date" placeholder="选择日期"></el-date-picker></el-form-item>
			<el-form-item class="item" label="身份证号" prop="cardid"><el-input v-model="form.cardid"></el-input></el-form-item>
			<el-form-item class="item" label="名族" prop="nation"><el-input v-model="form.nation"></el-input></el-form-item>
			<el-form-item class="item" label="出生日期" prop="day"><el-date-picker style="width: 200px;" v-model="form.day" type="date" placeholder="选择日期"></el-date-picker></el-form-item>
			<el-form-item class="item" label="农历生日" prop="cday"><el-input v-model="form.cday"></el-input></el-form-item>
			<el-form-item class="item" label="户籍地址" prop="add"><el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.add"></el-input></el-form-item>
			<el-form-item class="item" label="现住址" prop="nowadd"><el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="form.nowadd"></el-input></el-form-item>
			<p class="tit">最高学历</p>
			<el-form-item class="item" label="证件号码" prop="eduid"><el-input v-model="form.eduid"></el-input></el-form-item>
			<el-form-item class="item" label="毕业日期" prop="eduday"><el-date-picker style="width: 200px;" v-model="form.eduday" type="date" placeholder="选择日期"></el-date-picker></el-form-item>
			<el-form-item class="item" label="毕业院校" prop="edusch"><el-input v-model="form.edusch"></el-input></el-form-item>
			<el-form-item class="item" label="专业" prop="edumajor"><el-input v-model="form.edumajor"></el-input></el-form-item>
			<el-form-item class="item" label="学历" prop="edu"><el-select v-model="form.edu" placeholder="学历"><el-option v-for="onexl in xueli" :key="'xl'+onexl" :label="onexl" :value="onexl"></el-option></el-select></el-form-item>
			<p class="tit">教师资格证</p>
			<el-form-item class="item" label="证件号码" prop="tchid"><el-input v-model="form.tchid"></el-input></el-form-item>
			<el-form-item class="item" label="发证日期" prop="tchday"><el-date-picker style="width: 200px;" v-model="form.tchday" type="date" placeholder="选择日期"></el-date-picker></el-form-item>
				<el-form-item class="item" label="种类" prop="tchtyp"><el-select v-model="form.tchtyp" placeholder="种类"><el-option v-for="onetyp in tchtyp" :key="'typ'+onetyp" :label="onetyp" :value="onetyp"></el-option></el-select></el-form-item>
				<el-form-item class="item" label="任教科目" prop="tchsub"><el-select v-model="form.tchsub" placeholder="任教科目"><el-option v-for="onesub in tchsub" :key="'tchsub'+onesub" :label="onesub" :value="onesub"></el-option></el-select></el-form-item>
				<el-form-item class="item" label="认定机构" prop="tchinst"><el-input v-model="form.tchinst"></el-input></el-form-item>
		</el-form>
	</el-drawer>
</template>

<script>
export default{
	name:'repinf',
	data() {
		return {
			xueli:["高中","专科","本科","研究生","博士"],
			tchtyp:["小学教师资格","初级中学教师资格","高级中学教师资格"],
			tchsub:["语文","数学","英语","物理","化学","生物","思想政治","历史","地理","体育","音乐","美术"],
			form:{},
			rules:{
				sex:[{validator:(rule,value,callback)=>{
					callback(this.myfun.stristext(value).msg)
				},trigger:'blur'}],
				startTimeS:[{validator:(rule,value,callback)=>{
					callback(this.myfun.stristext(value).msg)
				},trigger:'blur'}],
			},
			inf:null,
		}
	},
	props:{
		user:{
			type:Object
		},
		show:{
			type:Boolean
		}
	},
	watch:{
		show(n){
			if(!n){
				return
			}
			//获取用户历史信息
			this.myfun.Loading()
			const formdata = new FormData()
			formdata.append("userid",this.user.id)
			this.axios.post("data:getOtherinf",formdata).then(e=>{
				this.myfun.Loadingclose()
				if(!e)return
				this.inf=e
				this.form = this.getinitform()
			})
		}
	},
	methods:{
		close(){
			this.$emit("close",{isrep:false})
		},
		reset(){
			this.form = this.getinitform()
		},
		submit(){
			this.$refs.from.validate((e)=>{
				if(!e){
					return
				}
				if(this.myfun.objIsSame(this.form,this.getinitform())){
					this.myfun.messageErr("信息未修改")
					return
				}
				const user=this.getsubmitdata()
				this.myfun.Loading()
				const formdata = new FormData()
				formdata.append("oldtime",this.user.stime)
				formdata.append("user",JSON.stringify(user))
				this.axios.post("data:repinf",formdata).then(e=>{
					this.myfun.Loadingclose()
					if(!e)return
					this.myfun.messageSuc("修改成功")
					this.$emit("close",{isrep:true,data:e})
				})
			})
		},
		getsubmitdata(){
			return {
				id:this.user.id,
				stime:this.myfun.date2str(this.form.startTimeS),
				card:{
					gender:this.form.sex,
					add:this.form.add,
					cday:this.form.cday,
					day:this.myfun.date2str(this.form.day),
					id:this.form.cardid,
					nation:this.form.nation,
					nowadd:this.form.nowadd,
				},
				edu:{
					day:this.myfun.date2str(this.form.eduday),
					edu:this.form.edu,
					id:this.form.eduid,
					major:this.form.edumajor,
					sch:this.form.edusch,
				},
				tch:{
					day:this.myfun.date2str(this.form.tchday),
					id:this.form.tchid,
					inst:this.form.tchinst,
					sub:this.form.tchsub,
					typ:this.form.tchtyp,
				}
			}
		},
		getinitform(){
			if(!this.show){
				return {sex:"",startTimeS:"",cardid:"",/*身份证号码*/nation:"",/*民族*/day:"",/*出生日期*/cday:"",/*农历生日*/add:"",/*户籍地址*/nowadd:"",/*现住址*/eduid:"",/*学历号*/eduday:"",/*毕业日期*/edusch:"",/*毕业学校*/edumajor:"",/*专业*/edu:"",/*学历*/tchid:"",/*教师证号码*/tchday:"",tchtyp:"",tchsub:"",tchinst:""}
			}
			return {
				sex:this.inf.card.gender,
				startTimeS:this.user.stime,
				cardid:this.inf.card.id,/*身份证号码*/
				nation:this.inf.card.nation,/*民族*/
				day:this.inf.card.day,/*出生日期*/
				cday:this.inf.card.cday,/*农历生日*/
				add:this.inf.card.add,/*户籍地址*/
				nowadd:this.inf.card.nowadd,/*现住址*/
				eduid:this.inf.edu.id,/*学历号*/
				eduday:this.inf.edu.day,/*毕业日期*/
				edusch:this.inf.edu.sch,/*毕业学校*/
				edumajor:this.inf.edu.major,/*专业*/
				edu:this.inf.edu.edu,/*学历*/
				tchid:this.inf.tch.id,/*教师证号码*/
				tchday:this.inf.tch.day,
				tchtyp:this.inf.tch.typ,
				tchsub:this.inf.tch.sub,
				tchinst:this.inf.tch.inst,
			}
		}
	}
}
</script>

<style scoped>
.tit{
	font-size: 18px;
	font-weight: 700;
	line-height: 30px;
	padding-left: 20px;
	margin-bottom: 10px;
	margin-top: 20px;
}
.item{
	width: 300px;
}
</style>
